import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { kyrgyzstanOrdersStore } from 'entities/kyrgyzstan/model'
import { KyrgyzstanBookingCard } from 'entities/kyrgyzstan/ui'
import userStore from 'entities/user/module/user-store'

import { previewPdfUrl } from 'shared/lib/pdf-preview'

interface ActiveBookingProps {
  className?: string
}

export const ActiveBooking = observer(({ className }: ActiveBookingProps) => {
  const navigate = useNavigate()

  const user = userStore.account

  const { lastActiveOrder, isLoadingLastActiveOrder, fetchLastActiveOrder } =
    kyrgyzstanOrdersStore

  useEffect(() => {
    if (user) {
      void fetchLastActiveOrder()
    }
  }, [fetchLastActiveOrder, user])

  const handleOpenDetails = () => {
    if (lastActiveOrder?.id) {
      navigate(RoutingPaths.kyrgyzstan.myOrders.detail.path(lastActiveOrder.id))
    }
  }

  const handleShowVoucher = () => {
    previewPdfUrl(lastActiveOrder?.file_url)
  }

  if (isLoadingLastActiveOrder || !lastActiveOrder) {
    return null
  }

  return (
    <KyrgyzstanBookingCard
      order={lastActiveOrder}
      onOpenDetails={handleOpenDetails}
      onShowVoucher={handleShowVoucher}
      className={className}
    />
  )
})
